import { requestApi } from './Api';

export const createMedication = (navigate, params, onError, onSuccess) =>
  requestApi({
    navigate,
    url: '/api/medications/create',
    params,
    onError,
    onSuccess
  });

export const getMedications = (navigate = () => {}, params) =>
  requestApi({
    navigate,
    url: '/api/medications/get',
    params
  });

export const deleteMedication = (navigate = () => {}, params) =>
  requestApi({
    navigate,
    url: '/api/medications/delete',
    params
  });
export const deleteMultipleMedications = (navigate = () => {}, params) =>
  requestApi({
    navigate,
    url: '/api/medications/multiple_delete',
    params
  });
export const updateMultipleMedications = (navigate = () => {}, params) =>
  requestApi({
    navigate,
    url: '/api/medications/multiple_update',
    params
  });
export const upsertWeightLossSync = (navigate = () => {}, params) =>
  requestApi({
    navigate,
    url: '/api/medications/upsert_weightloss_sync',
    params
  });
export const addMedicationToWeightLoss = (navigate = () => {}, params) =>
  requestApi({
    navigate,
    url: '/api/medications/add_medication_weightloss',
    params
  });
export const syncMedicationsFromOverview = (navigate = () => {}, params) =>
  requestApi({
    navigate,
    url: '/api/medications/sync_from_overview',
    params
  });
